import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Button } from 'antd';
import JSONView from 'react-json-view';
import './PaymentLogModal.css';

const { Text } = Typography;

@inject(
    'PaymentLogStore'
)
@observer
class PaymentLogModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    cancelPaymentLogDetailOnClick = () => {
        this.props.PaymentLogStore.setshowPaymentLogModal(false);
    }

    render() {
        const {
            paymentLog,
            paymentLogModalLoading
        } = this.props.PaymentLogStore;

        return (
            <>
                {
                    paymentLog
                        ?
                        <>
                            <Spin spinning={paymentLogModalLoading}>
                                <Row className='paymentlogmodal-row-container'>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>#ID</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.paymentId}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>#Check Number</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.orderNumber}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Amount</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{Math.round(paymentLog.amount * 100) / 100}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Payment Status</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.paymentStatus}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Order Status</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.orderStatus}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Room No</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.roomNo}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Last Name</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.lastName}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Payment Created Date</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.paymentCreatedAtString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Payment Success Date</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.paymentSuccessAtString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Order Completed Date</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input'>
                                                <span>{paymentLog.orderCompletedAtString}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col'>
                                        <Row>
                                            <Col span={8} className='paymentlogmodal-col-label'>
                                                <Text className='paymentlogmodal-text-label'>Detail</Text>
                                            </Col>
                                            <Col span={16} className='paymentlogmodal-col-input json-viewer'>
                                                <JSONView
                                                    src={JSON.parse(paymentLog.orderDetail)}
                                                    displayDataTypes={false}
                                                    displayObjectSize={false}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='paymentlogmodal-col-button'>
                                        <Button type='primary' className='paymentlogmodal-button' onClick={this.cancelPaymentLogDetailOnClick}>Close</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default PaymentLogModalPage;